import { toast } from "react-toastify";
import firebase from "../../config/firebase";

export const addCatalog = (obj, onSuccess) => async (dispatch) => {
  dispatch({ type: "ADD_CATALOG_LOADER", payload: true });
  firebase
    .firestore()
    .collection("catalogs")
    .add(obj)
    .then(() => {
      dispatch({ type: "ADD_CATALOG_LOADER", payload: false });
      toast.success("Catalog Added Successfully");
      onSuccess();
    })
    .catch((err) => {
      toast.error(err.message);
      dispatch({ type: "ADD_CATALOG_LOADER", payload: false });
    });
};

export const getCatalogsByID = (ID) => async (dispatch) => {
  try {
    dispatch({ type: "GET_CATALOG_LOADER", payload: true });
    firebase
      .firestore()
      .collection("catalogs")
      .where("restaurantID", "==", ID)
      .onSnapshot((query) => {
        let temp = [];
        query.docs.forEach((doc) => {
          temp.push({
            id: doc.id,
            ...doc.data(),
          });
        });
        dispatch({ type: "GET_CATALOGS", payload: temp });
        dispatch({ type: "GET_CATALOG_LOADER", payload: false });
      });
  } catch (err) {
    dispatch({ type: "GET_CATALOG_LOADER", payload: false });
    toast.error(err.message);
  }
};

export const updateCatalog = (id, obj, onSuccess) => async (dispatch) => {
  dispatch({ type: "UPDATE_CATALOG_LOADER", payload: true });
  const docRef = firebase.firestore().collection("catalogs").doc(id);
  docRef
    .set(obj)
    .then(() => {
      dispatch({ type: "UPDATE_CATALOG_LOADER", payload: false });
      toast.success("Catalog Updated Successfully");
      onSuccess();
    })
    .catch((err) => {
      alert(err.message);
      dispatch({ type: "UPDATE_CATALOG_LOADER", payload: false });
    });
};

export const deleteCatalogsByID = (ID, onSuccess) => async (dispatch) => {
  dispatch({ type: "DELETE_CATALOG_LOADING", payload: true });
  firebase
    .firestore()
    .collection("catalogs")
    .doc(ID)
    .delete()
    .then(() => {
      dispatch({ type: "DELETE_CATALOG_LOADING", payload: false });
      toast.success("Catalog Deleted Successfully");
      onSuccess();
    })
    .catch((err) => {
      alert(err.message);
      dispatch({ type: "DELETE_CATALOG_LOADING", payload: false });
    });
};
